// filepath: src/components/inventory/InventoryGrid.js
import React from "react";
import ProductCard from '../../CommonComponents/ProductCard';
import { MdEdit } from "react-icons/md";




const InventoryGrid = ({ inventories, onAdjust, onEdit, uploadsBaseURL, selectedBranchId = "" }) => (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {inventories.map(inv => (
            <div key={inv.id}>
                <ProductCard
                    product={{
                        id: inv.id,
                        name: inv.product_name,
                        image: inv.image_url ? `${uploadsBaseURL}/${inv.image_url}` : null,
                        stock: selectedBranchId ? (inv.released_quantity ?? 0) : inv.quantity,
                        description: inv.description || inv.product_description || '',
                        price: typeof inv.price === 'number' && inv.price > 0 ? inv.price : '',
                    }}
                    showAddToCart={false}
                    showEdit={false}
                    onIncrease={e => { if (e) e.stopPropagation(); onAdjust(inv.id, +1); }}
                    onDecrease={e => { if (e) e.stopPropagation(); onAdjust(inv.id, -1); }}
                    uploadsBaseURL={uploadsBaseURL}
                    mode="inventory"
                    disableIncrease={Boolean(selectedBranchId) && (Number(inv.quantity) || 0) <= 0}
                >
                    <div className="ml-2 mt-2">
                        <button
                            type="button"
                            onClick={onEdit ? () => onEdit(inv) : undefined}
                            className="cursor-pointer w-8 h-8 rounded-xl flex items-center justify-center shadow-sm transition hover:scale-[1.03]"
                            style={{
                                background: 'linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 78%, black))',
                                color: 'var(--color-text, #fff)',
                            }}
                            title="Edit"
                        >
                            <MdEdit size={14} color="#fff" />
                        </button>
                    </div>
                </ProductCard>
            </div>
        ))}
    </div>
);

export default InventoryGrid;
